import { Component, ChangeDetectionStrategy, ViewEncapsulation, inject } from '@angular/core';
import { MatSnackBarRef, MatSnackBarAction } from '@angular/material/snack-bar';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'falcon-form-save-action',
  templateUrl: './form-save-action.component.html',
  styleUrls: ['./form-save-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatButton, MatSnackBarAction, TranslateModule],
})
export class FormSaveActionComponent {
  matSnackBarRef = inject<MatSnackBarRef<FormSaveActionComponent>>(MatSnackBarRef);

  save(): void {
    this.matSnackBarRef.dismissWithAction();
  }
}
